import ky from 'ky';

import { TB_ASSISTANT_BASE_URL } from './assistant.constants';

export async function checkIsAiAssistantAvailable() {
    try {
        await ky.head(`${TB_ASSISTANT_BASE_URL}/assistant/status`, { timeout: 1000 });

        return true;
    } catch {
        return false;
    }
}

export async function sendMessage(message: string, userId: string, signal: AbortSignal) {
    return ky.post(`${TB_ASSISTANT_BASE_URL}/assistant/chat_stream`, {
        json: {
            message,
            user_id: userId
        },
        signal
    });
}
